import { escapeHtml } from '@messenger/utils'
import { formFieldKeys } from '@messenger/consts'

/**
 * The block fields that hold plain text with line breaks rather than rich
 * text: the family appreciation message, which m3 and the case form write
 * from a plain textarea.
 */
export const PLAIN_TEXT_BLOCK_PATHS: ReadonlySet<string> = new Set([
  formFieldKeys.familyAppreciationMessage,
])

/**
 * A plain-text block as TinyMCE paragraphs: one `<p>` per line, each line
 * escaped, a blank line kept as an empty paragraph so the family's spacing
 * prints, leading and trailing ones included. An empty or whitespace-only
 * value gives ''.
 */
export const plainTextBlockToHtml = (value: unknown): string => {
  const text = typeof value === 'string' ? value : ''
  if (!text.trim()) return ''
  return text
    .split(/\r?\n/)
    .map((line) => `<p>${escapeHtml(line) || '&nbsp;'}</p>`)
    .join('')
}
